
seedWebApp.controller('SkuFavoritesModalController', ['$scope', '$uibModalInstance', 'TranslationService','favorites', 'favorite','product', 'contactID',
    function SkuFavoritesModalController($scope, $uibModalInstance, TranslationService, favorites, favorite, product, contactID) {

        $scope.translation = TranslationService.getActiveTranslation();
        //console.log('OrderAcceptModalCtrl.order');

        console.log('SkuFavoritesModalController');

        //console.log(order);
        $scope.favorites = favorites;
        $scope.product = product;

        /*
        if (favorite && favorite.AllItems) {
            favorite = null;
        }
        */

        /*
        if (!favorite) {
            favorite = { FavoriteName: 'New List', Skus: [] };
            if (favorites) {
                favorites.push(favorite);
            }
        }
        */
        $scope.contactID = contactID;
        $scope.favorite = favorite;

        $scope.isListSelected = function () {
            if (!$scope.favorite) {
                return false;
            }
            if ($scope.favorite.AllItems) {
                return false;
            }
            return true;
        };

        $scope.save = function () {
            $scope.msgError = '';

            if (!$scope.isListSelected()) {
                $scope.msgError = 'Must select a list to include';
                return;
            }

            if ($scope.favorite) {
                //$scope.favorite.Skus.push({ SkuID: product.SkuID, SkuName: product.SkuName });
                $scope.favorite.Skus.push(product.SkuID);
            }
            $uibModalInstance.close($scope.favorite);
        };

        $scope.add = function ()
        {
            $uibModalInstance.close();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }]
);